<div class="header-container top-container" [ngClass]="{ 'mt-[130px]!': userService.showRepairerWarningBanner() }">
  <form [formGroup]="generateReportForm" (ngSubmit)="generateReport()">
    <div class="search-inputs" [class.clear-button]="selectedInsurer">
      <mat-form-field class="range-field primary-icon">
        <mat-label>Time Range</mat-label>
        <mat-date-range-input [rangePicker]="rangePicker">
          <input matStartDate formControlName="startDate" placeholder="Start date" required />
          <input matEndDate formControlName="endDate" placeholder="End date" (dateChange)="dateChange()" required />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #rangePicker [calendarHeaderComponent]="DatepickerRangeComponent" />
        <mat-hint>DD/MM/YYYY - DD/MM/YYYY</mat-hint>
        @if (
          (startDate.hasError('required') || endDate.hasError('required')) &&
          !startDate.hasError('matDatepickerParse') &&
          !endDate.hasError('matDatepickerParse')
        ) {
          <mat-error>
            @if (startDate.hasError('required')) {
              <span>Start date is <strong>required</strong>. </span>
            }
            @if (endDate.hasError('required')) {
              <span> End date is <strong>required.</strong></span>
            }
          </mat-error>
        }
        @if (startDate.hasError('matStartDateInvalid') || endDate.hasError('matEndDateInvalid')) {
          <mat-error>
            <div>Start date must be on or before end date</div>
          </mat-error>
        }
        @if (startDate.hasError('matDatepickerParse') || endDate.hasError('matDatepickerParse')) {
          <mat-error> The date format is <strong>DD/MM/YYYY - DD/MM/YYYY</strong> </mat-error>
        }
      </mat-form-field>

      <mat-form-field class="status-field" [class.clear-show-button]="selectedInsurer">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status" [(value)]="selectedType">
          @for (type of reportTypes; track type) {
            <mat-option [value]="type.value">{{ type.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="insurer-field" [class.clear-show-button]="selectedInsurer">
        <mat-label>Insurer</mat-label>
        <mat-select [formControl]="insurer" multiple>
          @for (insurer of insurers; track insurer) {
            <mat-option (onSelectionChange)="change($event)" [value]="insurer.id">{{ insurer.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (selectedInsurer) {
        <mat-icon class="clear" (click)="clearAllSelection($event)" matSuffix>backspace_24px </mat-icon>
      }
    </div>
    <div class="report-button">
      @if (buttonPrimary) {
        <button
          matButton="text"
          class="generate-report-button subtitle-1"
          type="submit"
          (click)="generateReport()"
          [disabled]="startDate.invalid || endDate.invalid">
          APPLY
        </button>
      } @else {
        <ng-container>
          <button
            matButton="elevated"
            class="red-button generate-report-button subtitle-1"
            type="submit"
            (click)="buttonPrimary = true; generateReport()"
            [disabled]="startDate.invalid || endDate.invalid">
            APPLY
          </button>
        </ng-container>
      }
    </div>
  </form>
</div>

<div class="report-section">
  <div class="header">
    @if (generateReportForm.invalid) {
      <div class="init-header">
        <div class="subtitle-2">
          <mat-icon>info_outline_24px</mat-icon>
          Define a date range to generate a report of jobs, their status and totals quoted, invoiced and authorised
        </div>
      </div>
    }
    @if (reportSummary?.reports?.length === 0) {
      <div class="no-result">
        <mat-card class="subtitle-2">
          <mat-icon>warning_24px</mat-icon>
          No results could be found. Please review your criteria.
        </mat-card>
      </div>
    }
    <ng-container *ngTemplateOutlet="loadingSpinner"></ng-container>
  </div>
  <div [class.hidden]="doNotShowReports">
    <div class="report">
      <h6 class="title">{{ reportSummary?.rows }} {{ reportSummary?.rows === 1 ? 'Claim' : 'Claims' }}</h6>
      <div class="amounts">
        <div class="totals">
          <div class="quoted">
            <span class="totals-title body-2">Total Quoted</span>
            <div class="total subtitle-2">$ {{ reportSummary?.totalQuotedAmount | number: '1.2-2' }}</div>
          </div>
          <div class="authorised">
            <span class="totals-title body-2">Total Authorised</span>
            <div class="total subtitle-2">$ {{ reportSummary?.totalAuthorizedAmount | number: '1.2-2' }}</div>
          </div>
          <div class="approved">
            <span class="totals-title body-2">Total Approved</span>
            <div class="total subtitle-2">$ {{ reportSummary?.totalApprovedAmount | number: '1.2-2' }}</div>
          </div>
        </div>
      </div>
      <div class="excel" [class.spinner-right]="loadingXlsx()">
        @if (!loadingXlsx()) {
          <mat-icon inline="true" (click)="exportAsXLSX()">file_download_24px </mat-icon>
        } @else {
          <mat-spinner class="loading-export" mode="indeterminate" [diameter]="21"></mat-spinner>
        }
      </div>
    </div>
  </div>
  <div class="content-report" [class.hidden]="doNotShowReports">
    <mat-divider></mat-divider>
    <div class="report-table" #tableContent>
      <div
        [ngClass]="{
          'large-screen': 1025 | breakObserver: 'min' | async,
          'small-screen': 1024 | breakObserver: 'max' | async
        }">
        <table
          mat-table
          [dataSource]="dataSource"
          (matSortChange)="sortChange($event)"
          matSort
          matSortDirection="asc"
          matSortActive="lastUpdateDate"
          matSortDisableClear>
          <ng-container matColumnDef="lastUpdateDate">
            <th mat-header-cell *matHeaderCellDef [class.active]="activeColumn === 'lastUpdateDate'" mat-sort-header>
              Last Received
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.lastUpdateDate ? (element.lastUpdateDate | dateepoch: timezone) : '' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="regoNumber">
            <th mat-header-cell *matHeaderCellDef [class.active]="activeColumn === 'regoNumber'" mat-sort-header>
              Registration
            </th>
            <td mat-cell *matCellDef="let element">
              <span [ngClass]="{ regoNumber: element.regoNumber }">{{ element.regoNumber }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="ownerName">
            <th mat-header-cell *matHeaderCellDef [class.active]="activeColumn === 'ownerName'" mat-sort-header>
              Owner
            </th>
            <td mat-cell *matCellDef="let element">{{ element.ownerName }}</td>
          </ng-container>
          <ng-container matColumnDef="claimNumber">
            <th mat-header-cell *matHeaderCellDef [class.active]="activeColumn === 'claimNumber'" mat-sort-header>
              Claim Number
            </th>
            <td mat-cell *matCellDef="let element">{{ element.claimNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="lastAssessmentAction">
            <th
              mat-header-cell
              *matHeaderCellDef
              [class.active]="activeColumn === 'lastAssessmentAction'"
              mat-sort-header>
              Last Assessment Action
            </th>
            <td mat-cell *matCellDef="let element">{{ element.lastAssessmentAction }}</td>
          </ng-container>
          <ng-container matColumnDef="quoteOriginalNumber">
            <th
              mat-header-cell
              *matHeaderCellDef
              [class.active]="activeColumn === 'quoteOriginalNumber'"
              mat-sort-header>
              Quote Number
            </th>
            <td mat-cell *matCellDef="let element">{{ element.quoteOriginalNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="insurerName">
            <th mat-header-cell *matHeaderCellDef [class.active]="activeColumn === 'insurerName'" mat-sort-header>
              Insurer Name
            </th>
            <td mat-cell *matCellDef="let element">{{ element.insurerName }}</td>
          </ng-container>
          <ng-container matColumnDef="assessorName">
            <th mat-header-cell *matHeaderCellDef [class.active]="activeColumn === 'assessorName'" mat-sort-header>
              Assessor
            </th>
            <td mat-cell *matCellDef="let element">{{ element.assessorName }}</td>
          </ng-container>
          <ng-container matColumnDef="vehicleDescription">
            <th
              mat-header-cell
              *matHeaderCellDef
              [class.active]="activeColumn === 'vehicleDescription'"
              mat-sort-header>
              Vehicle Description
            </th>
            <td mat-cell *matCellDef="let element">{{ element.vehicleDescription }}</td>
          </ng-container>
          <ng-container matColumnDef="quoteDate">
            <th mat-header-cell *matHeaderCellDef [class.active]="activeColumn === 'quoteDate'" mat-sort-header>
              Quote Submitted
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.quoteDate ? (element.quoteDate | dateepoch: timezone) : '' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="authorizedDate">
            <th mat-header-cell *matHeaderCellDef [class.active]="activeColumn === 'authorizedDate'" mat-sort-header>
              Repairs Authorised
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.authorizedDate ? (element.authorizedDate | dateepoch: timezone) : '' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="approvedDate">
            <th mat-header-cell *matHeaderCellDef [class.active]="activeColumn === 'approvedDate'" mat-sort-header>
              Invoice Approved
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.approvedDate ? (element.approvedDate | dateepoch: timezone) : '' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="quotedAmount">
            <th mat-header-cell *matHeaderCellDef [class.active]="activeColumn === 'quotedAmount'" mat-sort-header>
              Total Quoted
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.quotedAmount !== 0 ? '$ ' + (element.quotedAmount | number: '1.2-2') : '' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="authorizedAmount">
            <th mat-header-cell *matHeaderCellDef [class.active]="activeColumn === 'authorizedAmount'" mat-sort-header>
              Total Authorised
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.authorizedAmount !== 0 ? '$ ' + (element.authorizedAmount | number: '1.2-2') : '' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="approvedAmount">
            <th mat-header-cell *matHeaderCellDef [class.active]="activeColumn === 'approvedAmount'" mat-sort-header>
              Total Approved
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.approvedAmount !== 0 ? '$ ' + (element.approvedAmount | number: '1.2-2') : '' }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="reportColumns; sticky: true"></tr>
          <tr
            mat-row
            [id]="row.jobId"
            *matRowDef="let row; columns: reportColumns"
            (click)="redirectToJob(row.jobId)"
            [class.highlight-active-job]="row.jobId === activeJobId"></tr>
        </table>
      </div>
    </div>
  </div>
</div>

<ng-template #loadingSpinner>
  @if (loading) {
    <div class="loading-result">
      <mat-spinner mode="indeterminate" [diameter]="21" />
      <div class="spinner-text subtitle-2">Loading...</div>
    </div>
  }
</ng-template>
